import CustomModal from '../../../Modal/CustomModal';
import React, { useEffect, useState } from 'react';
import { PHOTO_PICKER_MODEL } from '../Models/Models';
import ContentPhotoPicker from './ContentPhotoPicker';
import CenterPhotoPicker from '../CenterPhotoPicker';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean show: variable to show modal
 * @param event onHide: event to close modal
 * @param string title: title for modal
 * @param string id: component identifier
 * @param model photoPicker: component model
 * @param useState setPhotoPicker: state to update the component model
 * @param string actionModel: string with option "create" or "update", this comes from the ACTION_MODEL
 * @param model accept: file formats and sizes accepted by the component
 * @param boolean showBtnDelete: default value is true, must be set to false if selected files are not required
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string titleModalEdit:  required if actionModel === ACTION_MODEL.UPDATE, title for modal
 * @param boolean showPreview: default value is true, must be set to false if preview visualization is not needed with the upload component
 * @param string classWith: for container size, used when centering the component (w-100, w-400px, other ), but it will always be centered
 * @param event handleDelete: required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param boolean emptyFields: default value is false
 */
const PhotoPickerModal = (
    {
        show,
        onHide,
        title,
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput,
        showBtnDelete,
        disabled,
        showBtnCamera,
        validateFace,
        classWith,
        showPreview,
        typeSuggestions
    }
) => {
    const [photoPickerAux, setPhotoPickerAux] = useState({ ...PHOTO_PICKER_MODEL});
    const [displayModal, setDisplayModal] = useState("")
    const [emptyFields, setEmptyFields] = useState(false)

    useEffect(() => {
        setPhotoPickerAux({ ...PHOTO_PICKER_MODEL, preview: photoPickerFile.preview, previewImage: photoPickerFile.previewImage })
    }, [show]);

    return (<>
        <CustomModal
            title={title}
            show={show}
            display={displayModal}
            onHide={() => {
                setEmptyFields(false);
                onHide();
            }}
            onConfirm={() => {
                if(photoPickerAux?.selfieSrc === null && photoPickerAux?.fileSelected === null && photoPickerAux?.srcSelected === null){
                    setEmptyFields(true);
                    return;
                }
                setEmptyFields(false);
                setPhotoPickerFile({ ...photoPickerAux })
                onHide();
            }}
            classNameBody="pt-2"
        >
            <div className='row'>
                <div className='col-12'>
                    <CenterPhotoPicker classWith={classWith}>
                        <ContentPhotoPicker
                            id={id}
                            accept={accept}
                            photoPickerFile={photoPickerAux}
                            setPhotoPickerFile={setPhotoPickerAux}
                            titleInput={titleInput}
                            required={true}
                            disabled={disabled}
                            showBtnCamera={showBtnCamera}
                            validateFace={validateFace}
                            showBtnDelete={showBtnDelete}
                            showPreview={showPreview}
                            typeSuggestions={typeSuggestions}
                            emptyFields={emptyFields}
                            inModal={true}
                            setDisplayModal={setDisplayModal}
                        />
                    </CenterPhotoPicker>
                </div>
            </div>

        </CustomModal>
    </>)

}
export default PhotoPickerModal;
